import React, { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "../components/Sidebar";
import { useLocation, useNavigate } from "react-router-dom";

export const AddCourse = () => {
  const [courseName, setCourseName] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate()
  const location = useLocation()

  const managers = [
    { name: "Employee Manager", path: "/employee-manager" },
    { name: "Student Manager", path: "/student-manager" },
    { name: "cold leads dump", path: "/nl-nc-student-manager" },
    { name: "College Manager", path: "/college-manager" },
    { name: "Course Manager", path: "/course-manager" },
    { name: "Admission Manager", path: "/admission-manager" }
  ];

  const handleSubmit = async(e) => {
    e.preventDefault();
    
    if (!courseName.trim()) {
      setError("Course Name is required.");
      return;
    }
    try {
      await axios.post(location?.state?.type !== "edit" ? `${process.env.REACT_APP_BASE_URL}/create-course` : `${process.env.REACT_APP_BASE_URL}/edit-course`, {name: courseName, _id: location?.state?.data?._id},{
        headers: {
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("token")}`,
        },
      });
      setCourseName("");
      navigate("/course-manager")
      setError(""); 
    } catch (error) {
      console.error("Error submitting data:", error);
    }
    setCourseName("");
  };

   useEffect(()=>{
       if((location.pathname === "/view-course" || location.pathname === "/edit-course") && !location.state){
         navigate("/course-manager")
       }
       if(location?.state?.type === "view" || location?.state?.type === "edit"){
        setCourseName(location?.state?.data?.name)
       }
    },[location])

  return (
    <div className="min-h-screen flex bg-gray-100">
      <Sidebar />
      <div className="flex-1 p-6">
        <h1 className="text-2xl font-bold mb-6">{location?.state?.type === "view" ? "View" : location?.state?.type === "edit" ? "Edit" : "Add New"} Course</h1>
        <div className="bg-white shadow-md rounded-lg p-6">
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-gray-700 font-bold mb-2">
                Course Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                value={courseName}
                disabled={location?.state?.type === "view"}
                onChange={(e) => {setCourseName(e.target.value)
                  setError("")
                }}
                className="border border-gray-300 rounded-md px-4 py-2 w-full"
                placeholder="Enter course name"
              />
              {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
            </div>
           {location?.state?.type !== "view" && <button
              type="submit"
              className="bg-blue text-white px-6 py-2 rounded-md shadow-md"
            >
              Submit
            </button>}
          </form>
        </div>
      </div>
    </div>
  );
};
